
import Form from 'react-bootstrap/Form';
import Style from '../../App.css'
import { createContext, useContext } from "react";

const districtContext = createContext();

function SelectShop(props){
    return <>
    <districtContext.Provider value={props.districtsList}>
        <Form.Group className="mb-3" >
            <Form.Select onChange={props.onChange}>
                <PrintGroup></PrintGroup>
            </Form.Select>
        </Form.Group>
    </districtContext.Provider>
  </>
};

function PrintGroup(){
    const districtList = useContext(districtContext);
    const uniqueTags = [];

    districtList.map(district => {
        if (uniqueTags.indexOf(district.District) === -1) {
            uniqueTags.push(district.District)
            //console.log(district.District)
        }
    });

    return uniqueTags.map((item) => 
        <optgroup key={item} label={item}>
            {districtList
                .filter(function(district){
                    return district.District === item})
                .map((district) => 
                    <PrintOption key={district.Loc_Id} value={district.Loc_Id} displayValue={district.Loc_Name} isShow={district.IsShown}></PrintOption>)
            }
        </optgroup>)
}

function PrintOption(props){
    return <>
        {
            props.isShow? 
            <option className={Style.no_item} value={props.value}>{props.displayValue}</option> :
            <option className={Style.has_item} value={props.value} disabled>{props.displayValue}</option>
        }
    </>
}

export default SelectShop;